module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "marquee-tips",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60e0c482","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-marquee-tips/src/components/MarqueeTips.vue
// module id = 236
// module chunks = 1